import { render } from "./bgImagesComponents.vue?vue&type=template&id=252566d6&scoped=true"
import script from "./bgImagesComponents.vue?vue&type=script&lang=js"
export * from "./bgImagesComponents.vue?vue&type=script&lang=js"

import "./bgImagesComponents.vue?vue&type=style&index=0&id=252566d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252566d6"]])

export default __exports__